export default {
    routes: {
        categoryMain: "category",
        pamMain: "pam"
    }
}